import { Box, Typography, useTheme } from "@mui/material";
import Friend from "components/Friend";
import WidgetWrapper from "components/WidgetWrapper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFriends } from "state";
import { BASE_URI } from "helper";

const FriendListWidget = ({ userId }) => {
  const dispatch = useDispatch();
  const { palette } = useTheme();
  const token = useSelector((state) => state.token);
  const friends = useSelector((state) => state.user.friends);
  const [load,setLoad] = useState(true);
  const loggedInUserId = useSelector((state) => state.user._id);

  useEffect(() => {
    const getFriends = async () => {
    const response = await fetch(
      `${BASE_URI}/users/${userId}/friends`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const data = await response.json();
    dispatch(setFriends({ friends: data }));
    setLoad(false);
  };
  getFriends();
  },[token,userId,dispatch]);


  return (
    <WidgetWrapper>
      <Typography
        color={palette.neutral.dark}
        variant="h5"
        fontWeight="500"
        sx={{ mb: "1.5rem" }}
      >
        Friend List
      </Typography>
      <Box display="flex" flexDirection="column" gap="1.5rem">

        { load===false ? 
        (
          friends.length!==0 && friends.map((friend) => (
            <Friend
              key={friend._id}
              friendId={friend._id}
              name={`${friend.firstName} ${friend.lastName}`}
              subtitle={friend.occupation}
              userPicturePath={friend.picturePath}
              userId={userId}
              loggedInUserId={loggedInUserId}
            />
          ))
        ) : (
          <div>Loading...</div>
        )
      }
      </Box>
    </WidgetWrapper>
  );
};

export default FriendListWidget;
